import { render } from "./CadastroUsuario.vue?vue&type=template&id=9af11844&scoped=true"
import script from "./CadastroUsuario.vue?vue&type=script&lang=js"
export * from "./CadastroUsuario.vue?vue&type=script&lang=js"

import "./CadastroUsuario.vue?vue&type=style&index=0&id=9af11844&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9af11844"]])

export default __exports__